import React from 'react';

const VersionHistoryPage = () => {
    return (
        <div className="container">
            <h1 className="header">Version History</h1>

            <h3>v0.24.0 — UI Polish &amp; Game Improvements</h3>
            <div>
                <ul>
                    <li>Wallet link moved from navbar to the Account page — cleaner navigation.</li>
                    <li>Tighter form fields and buttons across the entire site.</li>
                    <li>Game page: bat and baseball icons on the button bar indicate which side is batting and pitching (green = you, red = CPU).</li>
                    <li>Game page: removed &quot;Next Batter&quot; / &quot;Next Pitcher&quot; labels — cards sit higher with more room for the play-by-play.</li>
                    <li>Game page: CPU side now has a maroon robot-head background pattern.</li>
                    <li>Meeple colors swapped — your runners are now red, CPU runners are green.</li>
                    <li>Fatigued pitchers (stamina at 0 or below) now glow red as a warning.</li>
                    <li>Fixed card sizing so both batter and pitcher cards are always the same size.</li>
                </ul>
            </div>

            <h3>v0.21.1 — New Variations: Red Shift &amp; Gold Shift</h3>
            <div>
                <ul>
                    <li>Two new card variations can now drop from packs: <b>Red Shift</b> and <b>Gold Shift</b>.</li>
                    <li><b>Red Shift</b> replaces all dark tones with deep red — no black, just red and white. 1 in 1,000 cards (1 in 500 from gold packs).</li>
                    <li><b>Gold Shift</b> does the same with gold tones. 1 in 2,000 cards (1 in 1,000 from gold packs).</li>
                </ul>
            </div>

            <h3>v0.21.0 — Redesigned Play-by-Play</h3>
            <div>
                <ul>
                    <li>The at-bat result now builds in right below the action buttons — batting dice, pitching dice, and the final outcome appear one step at a time so you can follow every roll.</li>
                    <li>Cards stay face-up the whole game — no more flipping on every pitch.</li>
                    <li>When the batter gets XB dice, only the extra-base dice are shown (no duplicate white dice).</li>
                    <li>The final result fills the row with a repeating ticker animation.</li>
                    <li>Mobile: compact two-letter abbreviations (BB, PW, KS, HS) and short labels (B: / P:) keep everything on one line.</li>
                </ul>
            </div>

            <h3>v0.20.0</h3>
            <div>
                <ul>
                    <li>Temp teams created from fatigue substitutions are now properly tracked and hidden from team selectors — no more TEMP clutter in your dropdowns.</li>
                    <li>Variation cards on your team lineup now show a badge (C, R, BW, N, F) so you can tell at a glance which cards are special.</li>
                </ul>
            </div>

            <h3>v0.19.0 — Card Variations</h3>
            <div>
                <ul>
                    <li>Cards can now drop as <b>variations</b> when you open packs — Black &amp; White, Negative, Chrome, Refractor, and the ultra-rare Fire.</li>
                    <li>Each variation has a unique visual effect on the card and on the baserunner meeple when that player is on base.</li>
                    <li>Gold packs have 2x the variation hit rate compared to base packs.</li>
                    <li>Hover over a baserunner to see their variation in the tooltip.</li>
                </ul>
            </div>

            <h3>v0.6.0</h3>
            <div>
                <ul>
                    <li>Hit the <b>Auto</b> button and let your team play on its own — the game rolls every 2 seconds without you clicking a thing. It pauses automatically when you need to make a decision (sending a runner, attempting a steal, making a substitution) and picks right back up once you&apos;re done.</li>
                </ul>
            </div>

            <h3>v0.5.0</h3>
            <div>
                <ul>
                    <li>Hover over any baserunner&apos;s name to see their speed rating — no more guessing whether to send them or hold them at third.</li>
                </ul>
            </div>

            <h3>v0.4.0</h3>
            <div>
                <ul>
                    <li>Your pitchers&apos; stamina is now visible right on their card — a fatigue indicator shows up so you always know who&apos;s running on fumes.</li>
                    <li>Before the first pitch, a pre-game panel flags any tired arms in your rotation so you can swap them out before it&apos;s too late.</li>
                    <li>A full participants section on the game page lets you keep tabs on both lineups while the game is going.</li>
                </ul>
            </div>

            <h3>v0.3.0</h3>
            <div>
                <ul>
                    <li>You&apos;ll stay logged in for up to 30 days automatically — no more getting kicked out mid-season.</li>
                </ul>
            </div>

            <h3>v0.2.0</h3>
            <div>
                <ul>
                    <li>When a pitcher is too gassed to keep going, you&apos;ll now get a prompt to pull him and bring in fresh arms.</li>
                    <li>A pre-game roster check shows you which players are already worn down before you even take the field.</li>
                </ul>
            </div>

            <h3>v0.1.1</h3>
            <div>
                <ul>
                    <li>Pitchers now wear down the more batters they face — leave your ace in too long and his stuff gets worse. Pull him before he blows the lead.</li>
                </ul>
            </div>

            <h3>.24</h3>
            <div>
                <ul>
                    <li>Try to steal a base</li>
                    <li>Runs, steals, and caught stealings are now credited to the right player</li>
                    <li>Steals and Caught Stealing now on the leaderboard</li>
                </ul>
            </div>

            <h3>.23</h3>
            <div>
                <ul>
                    <li>Accurate hit locations</li>
                    <li>Try to take an extra base</li>
                    <li>Try to tag up</li>
                    <li>No longer add the same card to two different positions</li>
                </ul>
            </div>
        </div>
    );
};

export default VersionHistoryPage;
